import React, { Fragment, useEffect, useState } from 'react';
import { insuranceNetworkContainer } from './utils/prop-types';
import { useQuery } from '@apollo/client';
import { Loader, Toaster } from '@td/ui';
import { uniqBy } from 'lodash';
import InsuranceNetworkList from './components/insurance-network-list';
import InsuranceNetworkCreateForm from './components/insurance-network-create-form';
import InsuranceNetworkSearch from './components/insurance-network-search';
import FETCH_INSURANCE_NETWORKS from './queries/fetch-insurance-networks.graphql';
import styles from './styles.module.scss';

const InsuranceNetworkContainer = ({ roles }) => {
  const [insuranceNetworks, setInsuranceNetworks] = useState(null);
  const [currentInsuranceNetworks, setCurrentInsuranceNetworks] = useState(null);
  const [selectedInsuranceNetwork, setSelectedInsuranceNetwork] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [showCreateForm, setShowCreateForm] = useState(false);

  const { loading, data } = useQuery(FETCH_INSURANCE_NETWORKS);

  useEffect(() => {
    if (data) {
      setInsuranceNetworks(data.insuranceNetworks);
      setCurrentInsuranceNetworks(data.insuranceNetworks);
    }
  }, [data]);

  const addInsuranceNetwork = insuranceNetwork => {
    const newInsuranceNetworks = [...insuranceNetworks];
    newInsuranceNetworks.unshift(insuranceNetwork);
    handleNewInsuranceNetworks(newInsuranceNetworks);
  };

  const updateInsuranceNetwork = insuranceNetwork => {
    const newInsuranceNetworks = [...insuranceNetworks];
    const index = newInsuranceNetworks.findIndex(
      item => item.id === insuranceNetwork.id
    );
    newInsuranceNetworks[index] = insuranceNetwork;
    handleNewInsuranceNetworks(newInsuranceNetworks);
  };

  const deleteInsuranceNetwork = id => {
    const newInsuranceNetworks = insuranceNetworks.filter(
      item => item.id !== id
    );
    handleNewInsuranceNetworks(newInsuranceNetworks);
  };

  const handleNewInsuranceNetworks = newInsuranceNetworks => {
    const insuranceNetworks = uniqBy(newInsuranceNetworks,
      insuranceNetwork => insuranceNetwork.name
    );
    setInsuranceNetworks(insuranceNetworks);

    const currentInsuranceNetworks = searchValue ?
      filterInsuranceNetworksByName(insuranceNetworks)
      : insuranceNetworks;

    setCurrentInsuranceNetworks(currentInsuranceNetworks);
  };

  const filterInsuranceNetworksByName = insuranceNetworks => {
    const lowerCaseName = searchValue.toLowerCase().trim();

    return insuranceNetworks.filter(insuranceNetwork =>
      insuranceNetwork.name.toLowerCase().includes(lowerCaseName)
    );
  };

  return (
    <Fragment>
      <h1>Insurance Network Management</h1>
      {
        loading ?
          <div
            className={styles.customLoader}
            data-testid='insurance-network-loader'
          >
            <Loader />
          </div>
          :
          insuranceNetworks ?
            <Fragment>
              <InsuranceNetworkSearch
                roles={roles}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                showCreateForm={showCreateForm}
                setShowCreateForm={setShowCreateForm}
                insuranceNetworks={insuranceNetworks}
                setCurrentInsuranceNetworks={setCurrentInsuranceNetworks}
                setSelectedInsuranceNetwork={setSelectedInsuranceNetwork}
              />
              <InsuranceNetworkCreateForm
                showCreateForm={showCreateForm}
                setShowCreateForm={setShowCreateForm}
                addInsuranceNetwork={addInsuranceNetwork}
              />
              <InsuranceNetworkList
                roles={roles}
                currentInsuranceNetworks={currentInsuranceNetworks}
                updateInsuranceNetwork={updateInsuranceNetwork}
                deleteInsuranceNetwork={deleteInsuranceNetwork}
                selectedInsuranceNetwork={selectedInsuranceNetwork}
                setSelectedInsuranceNetwork={setSelectedInsuranceNetwork}
                searchValue={searchValue}
                setShowCreateForm={setShowCreateForm}
              />
              <Toaster />
            </Fragment>
            :
            <span data-testid='label-error'>Something went wrong</span>
      }
    </Fragment>
  );
};

InsuranceNetworkContainer.propTypes = insuranceNetworkContainer;

export default InsuranceNetworkContainer;
